import { useLocation } from "react-router-dom";
import { parseQueryString } from "../services/parseQueryString";

const useQueryString = () => {
  const location = useLocation();
  return parseQueryString(location.search || "");
};

export default useQueryString;